/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Max_Hr_HintInputs */

const en_ui_onboarding_max_hr_hint = /** @type {(inputs: Ui_Onboarding_Max_Hr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highest value in an all-out effort`)
};

const de_ui_onboarding_max_hr_hint = /** @type {(inputs: Ui_Onboarding_Max_Hr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchster Wert bei voller Belastung`)
};

/**
* | output |
* | --- |
* | "Highest value in an all-out effort" |
*
* @param {Ui_Onboarding_Max_Hr_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_max_hr_hint = /** @type {((inputs?: Ui_Onboarding_Max_Hr_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Max_Hr_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_max_hr_hint(inputs)
	return de_ui_onboarding_max_hr_hint(inputs)
});